import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

function readMoreClick(event){
    // debugger;
    if (event.target.innerHTML == "Read More") {
        event.target.innerHTML = "Read Less";
        event.target.previousSibling.style.height = 'auto';
        event.target.previousSibling.classList.remove('line-clamp');
    } else {
        event.target.innerHTML = "Read More";
        event.target.previousSibling.style.height = '40px';
        event.target.previousSibling.classList.add('line-clamp');
    }
}

export default function VaccinationSection ({vaccData, eleRef}){
    // console.log("vaccData --- ", vaccData);
    return(
        <section className="vacc-section tracker">
            {global.ftk && vaccData.vaccination.length > 0 ? 
            <div>
                <div className="sect-title M15_42">VACCINATION TRACKER</div>
                {vaccData.vaccination && vaccData.vaccination.map((vacc, id) => 
                <div key={id} className="vacc-block">
                    <div className="section-title">
                        <div className="vacc-icons left">
                            <span className="vc_bgimg icon" data-icon-font={vacc.icon}></span>
                            <span className="vc_frimg icon" data-icon-font={vacc.icon}></span>
                        </div>
                        <div className="username vacc-month left">{vacc.stageid} months</div>
                    </div>
                    <div className="vacc-details">
                        <div className="vacc-img-det left">
                            <div className="vacc-img">
                                <span data-icon-font="S" style={{color: vacc.icon}}></span>
                            </div>
                            <div className="M14_42">
                                {vacc.vaccinetitle}
                            </div>
                            <div className="vacc-dose">({vacc.dosetitle})</div>
                        </div>
                        <div className="vacc-info left">
                            <div className="due-on-reminder">
                                <div className="M12_42">Due on</div>
                                <div className="M12_42">Reminder set for</div>
                            </div>
                            <div className="dates">
                                <div className="vacc_dt">{vacc.dueon}</div>
                                <div className="vacc_dt">5 jan 2020 <span className="" data-icon-font="w"></span></div>
                            </div>
                            <div className="vacc-descp line-clamp R14_75">
                                {vacc.description}
                            </div>
                            <div className="vacc-readmore R13_link" onClick={(e) => readMoreClick(e)}>Read More</div>
                        </div>
                    </div>
                </div>
                )}
                {vaccData.search_cnt > vaccData.vaccination.length &&
                <div className="moreResults dev_v_all" title="VACCINATION TRACKER" onClick={()=>eleRef.getMoreSearchData(vaccData.type)}>SEE MORE RESULTS</div>
                }
            </div>
            : 
            <div>
                <div className="section-title">VACCINATION TRACKER</div>
            <div className="non_loggedin" id="non_loggedin">
                <div className="vacc-img left">
                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/ic_vaccination_tracker_rounded.jpg" alt="Child Vaccination Tracker" title="Child Vaccination Tracker" />
                </div>
                <ul className="vacc-features left">
                    <li>
                        <span className="vc_gr_icons left" data-icon-font="$"></span>
                        <span  className="R11_42 left feature">Track Upcoming Vaccination</span>
                    </li>
                    <li>
                        <span className="vc_gr_icons left" data-icon-font="B"></span>
                        <span  className="R11_42 left feature">Check Vaccination Status</span>
                    </li>
                    <li>
                        <span className="vc_gr_icons left" data-icon-font="5"></span>
                        <span  className="R11_42 left feature">Get notifications & schedule reminder</span>
                    </li>
                    <li>
                        <span className="vc_gr_icons left" data-icon-font="."></span>
                        <span  className="R11_42 left feature">Maintain digital records</span>
                    </li>
                </ul>
            </div>
            {global.ftk && vaccData.vaccination.length <= 0 ?
            <div className="moreResults dev_v_all" title="VACCINATION TRACKER" onClick={()=>{service.showAlert("Please Enter Child");
            window.location.href = '/my-account';}}>SEE MORE RESULTS</div>
            :
            <div className="moreResults dev_v_all" title="VACCINATION TRACKER" onClick={()=>actions.nonLoggedin()}>SEE MORE RESULTS</div>
            }
            </div>
            }
        </section>
    );
}
